import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-horizontal-rule',
  templateUrl: './horizontal-rule.component.html'
})
export class HorizontalRuleComponent implements OnInit {

  @Output() controlReady = new EventEmitter<boolean>();
  constructor() { }

  // tslint:disable-next-line: completed-docs
  ngOnInit(): void {
    this.notifyControlLoadComplete();
  }

  /**
   * This method will notify when control is ready
   */
  private notifyControlLoadComplete() { this.controlReady.emit(true); }

}
